<template>
    <oss-dialog
        v-model="dialog"
        v-if="dialog"
        :max-width="$vuetify.display.mobile ? 'auto' : '800px'"
        :min-width="$vuetify.display.mobile ? 'auto' : '800px'"
        :title="'Ajouter un abonnement'"
        @close="close()"
    >
        <template v-slot:actions>
            <v-btn-primary rounded block @click="valid()" :disabled="!isValid" size="x-large">{{
                displayBtnValue()
            }}</v-btn-primary>
        </template>

        <v-form v-model="isValid">
            <v-row>
                <v-col cols="12" md="8">
                    <v-text-field-filled
                        v-model="subscription.title"
                        label="Libellé"
                        outlined
                        hide-details
                        :rules="[(v) => !!v || $t('settings.itemRequired')]"
                        density="compact"
                    />
                </v-col>
                <v-col cols="4" class="pl-1">
                    <v-text-field-filled
                        v-model="subscription.netAmount"
                        label="Montant HT Mensuel"
                        outlined
                        dense
                        hide-details
                        :rules="[(v) => !!v || $t('settings.itemRequired')]"
                    >
                    </v-text-field-filled>
                </v-col>
            </v-row>
            <v-row>
                <v-col cols="6">
                    <AccountableAccount
                        v-show="true"
                        :showLabel="true"
                        :label="'Compte de charges'"
                        :inputStyle="'padding:0px; margin:0px;'"
                        :showValidation="false"
                        :companyId="companyId"
                        :showDescription="true"
                        :inAccountableAccountType="'Selected'"
                        :inAccountableAccountNames="expenseAccountableAccounts"
                        :inAccountableAccount="accountableAccountExpense"
                        :disabled="false"
                        :hideDetails="true"
                        @select-accountableAccount="selectAccountableAccountExpense"
                        :defineThirdParty="false"
                        dense
                    />
                </v-col>
                <v-col cols="6" class="pl-1">
                    <v-text-field-filled
                        v-model="subscription.aaSubscriptionName"
                        label="Compte d'abonnements"
                        outlined
                        hide-details
                        readonly
                        disabled
                        :rules="[(v) => !!v || $t('settings.itemRequired')]"
                        density="compact"
                    />
                </v-col>
            </v-row>
            <v-row class="mb-2">
                <v-col class cols="6">
                    <oss-date-picker-filled
                        v-model="subscription.startDate"
                        :label="'Date de début'"
                        :textFieldReadOnly="false"
                        :rules="[(v) => !!v || $t('settings.itemRequired')]"
                        hide-details
                    />
                </v-col>
                <v-col class="pl-1" cols="6">
                    <v-select-filled
                        v-model="subscription.periodicity"
                        label="Durée abonnement"
                        :items="periodicity"
                        item-value="value"
                        outlined
                        hide-details
                        :rules="[(v) => !!v || $t('settings.itemRequired')]"
                        density="compact"
                        :item-title="(item) => item.name"
                    />
                </v-col>
            </v-row>
            <!-- <v-row class="mt-2">
                    <v-col cols="4">
                        <oss-text-field
                            v-model="subscription.netAmount"
                            label="Montant HT Mensuel"
                            class="oss-"
                            outlined
                            dense
                            hide-details
                            @change="calculateGrossAmount()"
                            :rules="[v => !!v || $t('settings.itemRequired')]"
                        >
                        </oss-text-field>
                    </v-col>
                    <v-col cols="4" class="pl-2">
                        <v-select
                            v-model="subscription.vatRate"
                            :items="vatRates"
                            label="Taux de TVA"
                            class="oss-"
                            return-object
                            outlined
                            dense
                            hide-details
                            @update:model-value="calculateGrossAmount()"
                            :rules="[v => !!v || $t('settings.itemRequired')]"
                        ></v-select>
                    </v-col>
                    <v-col cols="4" class="pl-2">
                        <oss-text-field
                            v-model="subscription.grossAmount"
                            label="Montant TTC Mensuel"
                            class="oss-"
                            outlined
                            dense
                            hide-details
                            @change="calculateNetAmount()"
                            :rules="[v => !!v || $t('settings.itemRequired')]"
                        >
                        </oss-text-field>
                    </v-col>
                </v-row> -->
        </v-form>
    </oss-dialog>
</template>
<script lang="ts">
import _ from "lodash";
// import { Apollo } from "@/decorators";
import { User } from "../../store/store";
import UPSERT_SUBSCRIPTION from "../../graphql/subscriptions/Subscriptions.gql";
import AccountableAccount from "../AccountableAccount.vue";
import { filterAccountableAccounts } from "../../../../backend/src/common/accountableAccount/accountableAccountServices";
import { Component, Vue, toNative } from "vue-facing-decorator";
import { Prop, Model } from "vue-facing-decorator";
import { Watch } from "vue-facing-decorator";

@Component({
    components: {
        AccountableAccount,
    },
    emits: ["subscription-upserted", "edit-done"],
})
export class Subscriptions extends Vue {
    @Model() value;
    @Prop({ default: "" }) companyId: string;
    @Prop({ default: null }) document: any;

    isValid = false;

    accountableAccountExpense = null;
    accountableAccountSubscription = null;

    isSubAAFromExpenseAA = false;

    currentDate = new Date();

    typeStatus = [
        { value: "TO_BE_DONE", name: "En cours" },
        { value: "DONE", name: "Terminée" },
    ];

    type = [{ value: "SUBSCRIPTION", name: "Abonnement" }];

    periodicity = [
        { value: 3, name: "3 mois" },
        { value: 6, name: "6 mois" },
        { value: 12, name: "12 mois" },
        { value: 24, name: "24 mois" },
        { value: 36, name: "36 mois" },
        { value: 48, name: "48 mois" },
    ];

    defautSubscription = {
        id: "",
        companyId: "",
        title: "",
        startDate: "",
        periodicity: null,
        grossAmount: null,
        netAmount: null,
        // vatRate: null,
        type: "SUBSCRIPTION",
        aaExpenseName: "",
        aaSubscriptionName: "",
    };
    subscription = _.cloneDeep(this.defautSubscription);

    @Watch("document", { deep: true })
    initialize() {
        if (this.document) {
            if (this.document?.data?.subscription) {
                this.subscription = JSON.parse(JSON.stringify(this.document.data.subscription));
            } else {
                this.subscription = _.cloneDeep(this.defautSubscription);
            }
        } else {
            this.subscription = _.cloneDeep(this.defautSubscription);
        }

        if (this.subscription.aaExpenseName) {
            this.accountableAccountExpense = {
                name: this.subscription.aaExpenseName,
            };
        }

        if (this.subscription.aaSubscriptionName) {
            this.accountableAccountSubscription = {
                name: this.subscription.aaSubscriptionName,
            };
        }
    }

    beforeMount() {
        debugger;
        this.initialize();
    }

    get selectedCompany() {
        return this.$store.state.selected_company;
    }

    get expenseAccountableAccounts() {
        const filteredExpenseAAs = filterAccountableAccounts(
            this.$store.state.accountableAccountTable,
            ["6"],
            [],
        );
        return filteredExpenseAAs.map((accountableAccount) => accountableAccount.name);
    }

    async selectAccountableAccountExpense(data) {
        this.accountableAccountExpense = _.cloneDeep(data.accountableAccount);

        if (this.accountableAccountExpense && this.accountableAccountExpense.name) {
            this.subscription.aaExpenseName = this.accountableAccountExpense.name;
        }
    }

    get allAvailableCompanies() {
        return this.$store.state.user.allAvailableCompanies;
    }

    get currentUser(): User {
        return this.$store.state.user;
    }

    get isAccountingUser() {
        return this.currentUser.isAccountingUser;
    }

    get dialog() {
        return this.value;
    }

    set dialog(event) {
        this.value = event;
    }

    async valid() {
        await this.upsertSubscription();
        this.close();
    }

    async upsertSubscription() {
        debugger;

        const upsertedSubscription = await this.$apollo.mutate({
            mutation: UPSERT_SUBSCRIPTION,
            variables: {
                id: this.document?.id || "",
                companyId: this.companyId,
                subscription: this.subscription,
            },
        });

        if (upsertedSubscription.data.upsertSubscription) {
            this.$emit("subscription-upserted", upsertedSubscription.data.upsertSubscription);
        }
    }

    // calculateNetAmount() {
    //     // debugger
    //     if (this.subscription.grossAmount && this.subscription.vatRate) {
    //         this.subscription.netAmount = this.subscription.grossAmount / (1 + this.subscription.vatRate.vatRate / 100)
    //     }
    // }

    @Watch("subscription.netAmount")
    calculateGrossAmount() {
        if (this.subscription.netAmount) {
            this.subscription.grossAmount = this.subscription.netAmount;
        }
    }

    @Watch("accountableAccountExpense", { deep: true })
    subscriptionAANameFromExpenseAA() {
        if (this.accountableAccountExpense) {
            let parentAccountableAccountExpense = this.expenseAccountableAccounts.find(
                (accountableAccount) =>
                    accountableAccount ===
                    this.accountableAccountExpense.name.substring(0, 3).padEnd(6, "0"),
            );

            // Peut être existe il une meilleure façon de faire ?
            if (!parentAccountableAccountExpense) {
                let n = 3;

                const truncateAAName = (accountableAccountName, length) => {
                    return accountableAccountName.substring(0, length).padEnd(6, "0");
                };

                while (!parentAccountableAccountExpense && n <= 6) {
                    let truncatedName = truncateAAName(this.accountableAccountExpense.name, n);
                    parentAccountableAccountExpense = this.expenseAccountableAccounts.find(
                        (accountableAccount) => accountableAccount === truncatedName,
                    );
                    n++;
                }
            }

            if (parentAccountableAccountExpense) {
                let accountableAccountExpense =
                    this.$store.state.accountableAccountTable.accountableAccounts.find(
                        (accountableAccount) =>
                            accountableAccount.name === parentAccountableAccountExpense,
                    );

                if (accountableAccountExpense) {
                    let subscriptionAAName = "488" + accountableAccountExpense.name.substring(0, 3);
                    let subscriptionAADescription =
                        "Abonnement - " + accountableAccountExpense.description;

                    if (subscriptionAAName && subscriptionAADescription) {
                        this.subscription.aaSubscriptionName =
                            subscriptionAAName + " - " + subscriptionAADescription;
                    }
                } else {
                    this.subscription.aaSubscriptionName = "488000";
                }
            } else {
                let subscriptionAADefault =
                    this.$store.state.accountableAccountTable.accountableAccounts.find(
                        (accountableAccount) => accountableAccount.name?.startsWith("488000"),
                    );

                if (subscriptionAADefault) {
                    this.subscription.aaSubscriptionName = subscriptionAADefault.name;
                } else {
                    this.subscription.aaSubscriptionName = "488000";
                }
            }
        }
    }

    close() {
        this.dialog = false;
        this.$emit("edit-done");
    }

    displayBtnValue() {
        if (this.document) {
            return "Modifier";
        }
        return "Ajouter";
    }
}

export default toNative(Subscriptions);
</script>
